let middlewares;
export function setMiddlewares(middlewareList) {
    middlewares = middlewareList;
}
/**
 * 指令处理
 * @param {HTMLElement} el DOM元素
 * @param {Object} binding 绑定数据
 */
export function bindMiddlewares(el, binding) {
    if (Array.isArray(middlewares)) {
        middlewares.forEach((middleware) => {
            middleware.useDirective(el, binding);
        });
    }
}
